import { IFooter } from '@models/IFooter';
import SiteEnum from '@models/enums/SiteEnum';
import SharedFooter from '@organisms/Footer/Footer';

const Footer = (props: IFooter) => (
  <SharedFooter {...props} site={SiteEnum.Deco} />
);

export default Footer;
